// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-submissions .filters,.form-submissions .filter-bar__wrapper{display:flex}.form-submissions .dropdown-menu-element__control{padding-left:65px}.justify-end .dropdown-menu-element__value-container{padding-right:0px;padding-bottom:10px}", ""]);
// Exports
module.exports = exports;
